import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';

class ShopShirts extends Component {
  render() {
    return (
      <div className="App">
        <img className="logo" src={logo} alt="Logo" />
        <br />
        <div>Thailand's Aikido Association Shop...</div>
        <br />
        <div><Link to="/shop-shirts1">WHITE THROW</Link></div>
        <br />
        <div><Link to="/shop-shirts2">BLACK THROW</Link></div>
        <br />
        <div><Link to="/shop-shirts3">WHITE BOKKEN</Link></div>
        <br />
        <div><Link to="/shop-shirts4">BLACK BOKKEN</Link></div>
        <br />
        <br />

        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="New Wave Consulting Group" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default ShopShirts;
